export const version = 'v2.2.4-2284-g710df2163'
